module.exports = __webpack_public_path__ + "dlssrvtline2/img/vi-fb-share.jpg?4bdef66d";